import React from "react";
import { NavLink } from "react-router-dom";
import AuthContext from 'store/AuthContext';
import './MainMenuMobile.css';

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

const MainMenuMobile: React.FC<MobileMenuProps> = ({ isOpen, onClose }) => {
    const authCtx = React.useContext(AuthContext);

    if (!isOpen) return null;

    return (
      <div className="mobile-main-menu">
        <button onClick={onClose} className="mobile-main-menu-close-button">
          &times;
        </button>
        <nav className="mobile-main-menu-content">
          <ul>
            <li>
                <NavLink to="/" onClick={onClose}>
                    <p>Home</p>
                </NavLink>
            </li>
            <li><a href="https://dimx.world">How It Works</a></li>
            <li>
              <NavLink to="/own-dimensions">
                  <p>Creative Studio</p>
              </NavLink>
            </li>
            <li><a href="https://dimx.world/#contact-us">Contact Us</a></li>
          </ul>
        </nav>
      </div>
    );
};

export default MainMenuMobile;